// Formatters shared by client and worker (the ICS feed labels invoices the
// same way the UI does). Client code re-exports these from primitives.tsx.

/** "#0207" — zero-padded per Henry's call; suffixed numbers pad the base
    ("231-2" → "#0231-2"); non-numeric numbers pass through. */
export function formatInvoiceNumber(n: string): string {
  const m = /^(\d+)(-\d+)?$/.exec(n);
  if (m) return `#${m[1].padStart(4, '0')}${m[2] ?? ''}`;
  return n.startsWith('#') ? n : `#${n}`;
}
